import React from "react";
import styled from "styled-components";

const FooterContainer = styled.footer`
  background-color: #f0f5f8;
  width: 100%;
  padding: 24px 0;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  z-index: 100;
  position: relative;
`;

const FooterContent = styled.div`
  width: 100%;
  max-width: 470px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 6px;
  color: #6b7280;
  font-feature-settings: "liga" off, "clig" off;
  font-family: Pretendard, -apple-system, BlinkMacSystemFont, system-ui, Roboto,
    "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR",
    "Malgun Gothic", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol",
    sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  text-align: left;
  padding: 0 20px;
`;

const InfoText = styled.p`
  margin: 0;
  padding: 0;
`;

const CopyrightText = styled.p`
  margin: 15px 0 0 0;
  padding: 0;
`;

const Footer = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <InfoText>사업자등록번호 : 121-81-78634</InfoText>
        <InfoText>법인명 : 법무법인 더 에이치 황해</InfoText>
        <InfoText>
          주소 : 인천광역시 미추홀구 학익소로 60, 제1, 2, 3, 5, 6층
          <br />
          (학익동, 반도빌딩)
        </InfoText>
        <InfoText>대표 : 천상현</InfoText>
        <InfoText>전화번호 : 032-251-1000</InfoText>
        <InfoText>E-mail : theh1000@lfthe-h.com</InfoText>
        <InfoText>통신판매신고번호 : 2022-인천미추홀-0172</InfoText>
        <CopyrightText>
          Copyright © 2025 성난 유심 피해자들 | 유심 해킹 피해자 <br />
          집단소송 All rights reserved.
        </CopyrightText>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer;
